export default "/images/vendor/flag-icon-css/flags/1x1/ar.svg?5a7c09af30ea06db87f16f582b2be3f6";